import { fadeIn } from 'styles/animations';
import React, { FC } from 'react';
import styled from 'styled-components';

interface Props {
	weight?: number;
	weightUnit?: string;
	color?: string;
	offsetLeft?: number;
	offsetTop?: number;
	delay: number;
	goal?: boolean;
}

const StyledAlert = styled.div<Props>`
	font-size: 15px;
	line-height: 12px;
	font-weight: 600;
	letter-spacing: 0.37px;
	color: #3d2277;
	position: absolute;
	padding: 6px 5px;
	border-radius: 5px;
	white-space: nowrap;
	background-color: ${({ color }) => color ?? 'white'};
	left: ${({ offsetLeft }) => (offsetLeft ?? 0) + 6}px;
	top: ${({ offsetTop }) => `calc(${offsetTop ?? 0}px - 10px)`};
	transform: translate(-50%, -100%);
	opacity: 0;
	animation: ${fadeIn} 0.7s ${({ delay }) => delay}s forwards;

	&::after {
		content: '';
		position: absolute;
		left: 50%;
		bottom: 0;
		width: 0;
		height: 0;
		transform: translate(-50%, 100%);
		border-left: 5px solid transparent;
		border-right: 5px solid transparent;
		border-top: 5px solid ${({ color }) => color ?? 'white'};
	}
`;

const GoalText = styled.div<{ offsetLeft?: number; offsetTop?: number }>`
	position: absolute;
	left: ${({ offsetLeft }) => offsetLeft ?? 0}px;
	top: ${({ offsetTop }) => `calc(${offsetTop ?? 0}px - 15px)`};
	transform: translate(0%, -50%);
	font-weight: 700;
	font-size: 20px;
	line-height: 23px;
	text-align: center;
	letter-spacing: -0.02em;
	text-transform: uppercase;
	color: #ffffff;
`;

export const Alert: FC<Props> = props => {
	const { weight, weightUnit, goal } = props;
	return (
		<StyledAlert {...props}>
			{weight}
			&nbsp;
			{weightUnit}
			{goal && <GoalText>GOAL</GoalText>}
		</StyledAlert>
	);
};
